import { flashes } from "@/mocks/gossip";
import SectionHead from "./SectionHead";

const tagBg: Record<string, string> = {
  加急: "bg-brand-500 text-white",
  独家: "bg-[#241b13] text-white",
  速递: "bg-gold-500 text-white",
  首发: "bg-brand-100 text-brand-800",
  快讯: "bg-stone-200 text-stone-700",
};

export default function FlashTimeline() {
  return (
    <section id="flash" className="relative scroll-mt-24 py-10 md:py-14">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-5">
        {/* 标题列 */}
        <div className="lg:col-span-2">
          <div className="lg:sticky lg:top-28">
            <SectionHead
              kicker="速递快讯"
              title="每分钟都在滚动的加急消息"
              desc="吃瓜前线速递快讯按时间实时推进。滚动核实机制让每一条更新都保留首发片段，也同步最新回应，一目了然。"
              align="left"
            />
            <div className="mt-6 flex items-center gap-3 rounded-2xl border border-stone-200 bg-white p-4">
              <span className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-500 text-white">
                <i className="ri-wifi-line text-lg" />
                <span className="live-dot absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full border-2 border-white bg-gold-500" />
              </span>
              <div>
                <p className="text-[13px] font-semibold text-[#241b13]">前线信号在线</p>
                <p className="text-[12px] text-stone-500">编辑部 7×24 滚动盯热点，刷新即有新料</p>
              </div>
              <span className="ml-auto inline-flex items-center gap-1 rounded-full bg-gold-100 px-2.5 py-1 text-[11px] font-bold text-gold-700">
                <i className="ri-arrow-up-line" />
                实时
              </span>
            </div>
          </div>
        </div>

        {/* 时间线 */}
        <div className="lg:col-span-3">
          <ol className="relative ml-2 border-l-2 border-stone-200 pl-6 md:pl-8">
            {flashes.map((f) => (
              <li key={f.time} className="group relative pb-6 last:pb-0">
                <span className="absolute -left-[31px] top-1.5 h-4 w-4 rounded-full border-[3px] border-brand-500 bg-paper transition-colors md:-left-[39px]" />
                <div className="rounded-2xl border border-stone-200 bg-white p-4 transition-colors hover:border-brand-200 hover:bg-brand-50/40 md:p-5">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-[12px] font-semibold text-brand-700">
                      <i className="ri-time-line mr-1" />
                      {f.time}
                    </span>
                    <span className={(tagBg[f.tag] || "bg-stone-100 text-stone-600") + " rounded-md px-2 py-0.5 text-[11px] font-bold"}>
                      {f.tag}
                    </span>
                    <span className="ml-auto inline-flex items-center gap-1 text-[12px] text-stone-400">
                      <i className="ri-fire-line text-gold-500" />
                      {f.heat.toLocaleString()} 讨论
                    </span>
                  </div>
                  <p className="mt-2 text-[15px] leading-relaxed text-stone-700">{f.text}</p>
                </div>
              </li>
            ))}
          </ol>
          <button className="mt-4 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-dashed border-brand-300 bg-brand-50/40 py-3 text-[13px] font-semibold text-brand-700 hover:bg-brand-100/60">
            <i className="ri-refresh-line" />
            再看一轮早前快讯
          </button>
        </div>
      </div>
    </section>
  );
}